import { createSlice } from '@reduxjs/toolkit';

export const postsSlice = createSlice({
    name: 'posts',
    initialState: {
        postToOpen: null
    },
    reducers: {
        setPostToOpen: (state, action) => {
            state.postToOpen = action.payload;
        }
    }
});

export const { setPostToOpen } = postsSlice.actions;

export default postsSlice.reducer;
